import { ChevronLeft, ChevronRight } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { useLang } from "@/lib/i18n";

const Nav = ({ dir, onClick }) => {
  const { t } = useLang();
  return (
  <button type="button" onClick={onClick} className={`hs-lb-nav ${dir === "prev" ? "left-2" : "right-2"}`} aria-label={t(dir === "prev" ? "photo.prev" : "photo.next")} data-testid={`photo-viewer-${dir}`}>
    {dir === "prev" ? <ChevronLeft size={22} /> : <ChevronRight size={22} />}
  </button>
  );
};

/** photos: [{ id, src, caption, description? }] */
export const PhotoViewer = ({ photos, index, setIndex }) => {
  const p = index === null ? null : photos[index];
  const go = (d) => setIndex((i) => (i + d + photos.length) % photos.length);
  const onKey = (e) => {
    if (e.key === "ArrowRight") go(1);
    if (e.key === "ArrowLeft") go(-1);
  };
  return (
    <Dialog open={!!p} onOpenChange={(o) => { if (!o) setIndex(null); }}>
      <DialogContent onKeyDown={onKey} className="max-w-[min(94vw,1100px)] border-white/10 bg-[#0d0c0a] p-3 text-[#efe8dc] sm:p-4" data-testid="photo-viewer">
        <DialogTitle className="sr-only">{p?.caption}</DialogTitle>
        {p && (
          <figure className="relative m-0">
            <img key={p.id} src={p.src} alt={p.caption} className="hs-lb-img mx-auto max-h-[76vh] w-auto max-w-full rounded-lg object-contain" data-testid="photo-viewer-img" />
            {photos.length > 1 && <><Nav dir="prev" onClick={() => go(-1)} /><Nav dir="next" onClick={() => go(1)} /></>}
            <figcaption className="mt-3">
              <div className="mono flex justify-between gap-4 text-[11px] text-[#b3aa9c]">
                <span data-testid="photo-viewer-caption">{p.caption}</span>
                <span>{index + 1} / {photos.length}</span>
              </div>
              {p.description && <p className="mt-2 text-sm text-[#b3aa9c]">{p.description}</p>}
            </figcaption>
          </figure>
        )}
      </DialogContent>
    </Dialog>
  );
};
